<template>
    <v-select
            :label="label"
            :items="ubicaciones"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            @input="actualizaValor($event)"
            @change="actualizaValor($event)"
            @blur="$emit('blur')"
            :error-messages="errores.collect('ubicacion')"
            v-validate="validate"
            data-vv-name="ubicacion"
            required
    >
    </v-select>
</template>
<script>
    export default {
        inject: ['$validator'],
        name: 'ubicacion-select',
        props: ['multiple', 'value', 'chips', 'validate', 'label'],
        data() {
            return {
                ubicaciones: [
                    {value: 'B', text: 'BUENOS AIRES'},
                    {value: 'M', text: 'MENDOZA'},
                ]
            }
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/UbicacionSelect.vue